<script setup>
import TitleAlertSaveImport from '@/components/common/TitleAlertSaveImport.vue'
import RiverWaterLevelTable from '@/components/boundary-condition/RiverWaterLevelTable.vue'
import ImportFileStepper from '@/components/common/ImportFileStepper.vue'
import DownloadDialog from '@/components/common/DownloadDialog.vue'
import BoundaryConditionWarning from './BoundaryConditionWarning.vue'
import BoundaryConditionAlert from '@/components/boundary-condition/BoundaryConditionAlert.vue'
import { boundaryConditionMixin } from '@/mixins/boundaryConditionMixin'
import { onMounted, ref } from 'vue'

const STORE_NAMESPACE = 'riverWaterLevel'
const riverWaterLevel = ref(null)

const {
  dialog,
  downloadDialog,
  exportDialog,
  writeLoading,
  fetchLoading,
  count,
  downloadLoading,
  exportLoading,
  items,
  importItems,
  ignoredReferencePoint,
  importItemCount,
  loading,
  templateFileName,
  exportFileName,
  years,
  importedYears,
  addNewItem,
  fetchYears,
  fetchAvailableReferencePoints,
  fetchOptions,
  changePaginatedPage,
  downloadTemplate,
  exportData,
  saveChanges
} = boundaryConditionMixin(STORE_NAMESPACE, riverWaterLevel)

onMounted(async () => {
  fetchLoading.value = true
  await fetchYears()
  await fetchAvailableReferencePoints()
  await fetchOptions()
  fetchLoading.value = false
})
</script>

<template>
  <v-card style="min-height: 8px" variant="flat" rounded="0">
    <template #loader="{ isActive }">
      <v-progress-linear :active="isActive" indeterminate color="primary" class="mx-1" />
    </template>
    <BoundaryConditionAlert
      v-if="!loading && !count"
      type="river water level"
      @import="dialog = true"
      @download="downloadDialog = true"
    />
    <div v-else>
      <RiverWaterLevelTable
        ref="riverWaterLevel"
        @changePage="changePaginatedPage"
        :items="items"
        :count="count"
        :years="years"
      >
        <template v-slot>
          <TitleAlertSaveImport
            v-if="!loading"
            export-text="data export"
            import-text="data import"
            download-text="template"
            @add="addNewItem"
            @save="saveChanges()"
            :loading-save="writeLoading"
            @import="dialog = true"
            :download-button="true"
            @download="downloadDialog = true"
            :export-button="true"
            @export="exportDialog = true"
          />
        </template>
      </RiverWaterLevelTable>
    </div>
    <v-dialog v-model="dialog" max-width="85%">
      <ImportFileStepper
        @close-dialog="dialog = false"
        :storeNamespace="STORE_NAMESPACE"
        text="river water level data"
      >
        <template v-slot>
          <BoundaryConditionWarning :ignored-reference-point="ignoredReferencePoint" />
          <RiverWaterLevelTable
            :items="importItems"
            :count="importItemCount"
            :years="importedYears"
            :editable="false"
          />
        </template>
      </ImportFileStepper>
    </v-dialog>
    <DownloadDialog
      @update:dialog="downloadDialog = $event"
      :dialog="downloadDialog"
      width="500"
      :file-name="templateFileName"
      :loading="downloadLoading"
      text="Download river water level template"
      @download="downloadTemplate()"
    ></DownloadDialog>
    <DownloadDialog
      @update:dialog="exportDialog = $event"
      :dialog="exportDialog"
      width="500"
      :file-name="exportFileName"
      :loading="exportLoading"
      text="Export river water level data"
      @download="exportData()"
    ></DownloadDialog>
  </v-card>
</template>
